import Immutable from "seamless-immutable";
import * as actionTypes from "./actionTypes";

const initialState = Immutable({
  byId: {},
  params: {},
  error: {},
  actionsloading: false,
});

export function pageTypesReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.FETCH_PAGE_TYPES:
      return {
        ...state,
        byId: {},
        actionsloading: true,
      };
    case actionTypes.FETCH_PAGE_TYPES_SUCCESS:
      return {
        ...state,
        byId: action.payload.byId || {},
        params: action.payload.params || {},
        actionsloading: false,
      };
    default:
      return state;
  }
}
